import Chip, { ChipProps } from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

const ChipWFB = styled(Chip)<ChipProps>(({ theme }) => ({
  backgroundColor: theme.palette.grey[800],
  color: 'white',
  textTransform: 'uppercase',
}));

export default ChipWFB;
